import noImgBike from '@/assets/img/no-bike.jpg';

class BikeImg {

  getCover (uri){
    if (uri && uri.destination) {

       return `${process.env.VUE_APP_BASE_URL}/${uri.destination.replace(process.env.VUE_APP_DESTINATION_URL, '')}/${uri.filename}`

    } else {
      return `${noImgBike}`
    }
  }

  getGallery (uri) {

    if (uri) {
      let arrFiles = [];

      if (uri){

         uri.forEach((item) => {
            arrFiles.push(
               {
                  originalname: item.originalname,
                  name: item.filename,
                  size: item.size,
                  type: item.mimetype,
                  url: `${process.env.VUE_APP_BASE_URL}/${item.destination.replace(process.env.VUE_APP_DESTINATION_URL, '')}/${item.filename}`
               }
            )
         });
      }
      return arrFiles;
    } else {
      return `${noImgBike}`
    }
  }
}

export default new BikeImg();
